<template>
    <div class="post-area" id="app-modules">
        <template v-if="!isPostLocked">
            <div class="post-row-items transition-component" :class="[animation, `row-${r.name}-module`]"
                v-for="(r, key) in blocks" :key="r.index">
                <module-container :name="r.name" :index="key" :store="store" :displayLanguage="currentLanguge" />
            </div>
            <pagination :store="store" v-if="has_pagination" />
        </template>
        <div v-else-if="isPostLocked" class="post-row-items post-is-locked">
            <div class="locked-wrapper">
                <login v-if="!isLoggedin" />
                <diamonds unlock-type="post" :post-id="postId" class="unlock-with-diamonds"
                    v-if="isLoggedin && visibility === 'diamond'" @unlocked="unlockPost" />
                <follow unlock-type="post" :post-id="postId" class="unlock-by-follow"
                    v-if="isLoggedin && visibility === 'follow'" @following="followAuthorPost" />
            </div>
        </div>
    </div>
    </div>
</template>

<script>
import store from '../store';
import ModuleContainer from './ModuleContainer';
import Login from './Lock/Login';
import Diamonds from './Lock/Diamonds';
import Follow from './Lock/Follow';
import Pagination from '../libs/PostPagination';

export default {
    data() {
        return {
            store,
        };
    },
    components: {
        ModuleContainer,
        Pagination,
        Login,
        Diamonds,
        Follow,
    },
    computed: {
        animation() {
            return this.$variables.post_animation_style != '' ? this.$variables.post_animation_style + ' animate__animated wfit' : ''
        },
        isPostLocked() {
            if (!this.canLock) {
                return false;
            }

            if (this.visibility == 'diamond') {
                return !this.isDiamondUnlocked
            }

            if (this.visibility == 'follow') {
                return !this.isFollowerLocked
            }

            return false;
        },
        canLock() {
            return this.$variables.can_lock_post
        },
        isDiamondUnlocked() {
            return this.store.state.settings.is_post_unlocked || false
        },
        isFollowerLocked() {
            return this.store.state.settings.is_user_following_author || false
        },
        visibility() {
            return this.store.state.settings.visibility
        },
        page() {
            return this.store.state.page - 1
        },
        pages() {
            return this.store.state.pages;
        },
        blocks() {
            return this.store.state.blocks;
        },
        currentLanguge() {
            return this.store.state.currentLanguge;
        },
        has_pagination() {
            return this.$variables.post_pagination && this.store.state.total_pages > 1
        },
        isLoggedin() {
            return this.$variables.user
        },
        postId() {
            return this.store.state.post_id
        },
    },
    beforeMount() {
        if (this.blocks) {
            this.updateCounter(this.blocks)
            this.changePage(this.page)
        }
    },
    created() {
        this.store.state.vm = this;
    },
    mounted() {
        this.$quizierEvent.onInit();
    },
    methods: {
        followAuthorPost: function (state) {
            this.store.state.settings.is_user_following_author = state
        },
        unlockPost: function (state) {
            this.store.state.settings.is_post_unlocked = state
        },
        changePage(page) {
            this.store.state.blocks = JSON.parse(JSON.stringify(this.pages[page]))
        },
        updateCounter(blocks) {
            let counter = 1;
            blocks.forEach(function (block, index) {
                const block_type = typeof block.contents['data'].block_type !== 'undefined' ? block.contents['data'].block_type : false;
                if (block_type == 'list' || block_type == 'rank') {
                    block.contents['data'].counter = counter
                    counter++;
                }
            });
        }
    },
    watch: {
        page: function (page, o) {
            this.changePage(page)
            Quizier.initSocial()
        }
    },
};
</script>
